import { render, staticRenderFns } from "./RecommendationHeader.vue?vue&type=template&id=218ded89&scoped=true&"
import script from "./RecommendationHeader.vue?vue&type=script&lang=js&"
export * from "./RecommendationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218ded89",
  null
  
)

export default component.exports